export default __webpack_public_path__ + "static/media/prato.9757b8cf.png";